import "./socials.scss"
import Button from "../../../../../components/button/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookSquare, faInstagram} from "@fortawesome/free-brands-svg-icons";
import config from "../../../../../../config";

const Socials = () => {

    return (
        <>
          <Button icon={<FontAwesomeIcon icon={faInstagram} />} onClick={() => window.open(config.socials.instagram)} />
          <Button icon={<FontAwesomeIcon icon={faFacebookSquare} />} onClick={() => window.open(config.socials.facebook)} />
        </>
    )
}

export default Socials;